export class Parcours {
  couleurs: string[];
  font_family: string;
}
